// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Invoices\DataProviders\InvoiceField
// Generated on: <normalized>

export enum InvoiceField {
  DB_TABLE = 'invoices',
  DB_IDENTIFIER = 'invoiceGUID',
  STATUS = 'invoiceStatus',
  INVOICE_DATE = 'invoiceDate',
  INVOICE_DATE_PAID = 'invoiceDatePaid',
  INVOICE_TERM = 'invoiceTerm',
  INVOICE_DESCRIPTION = 'invoiceDescription',
  INVOICE_DETAILS = 'invoiceDetails',
  PURCHASE_ORDER = 'invoicePurchaseOrder',
  NET = 'net',
  TAX = 'tax',
  CLIENT_GUID = 'clientGUID',
  QUOTE_GUID = 'quoteGUID',
  REVENUE_STREAM_GUID = 'revenueStreamGUID',
  PAYMENT_TYPE = 'paymentType',
  PAYMENT_DATA = 'paymentData',
  PRE_PAYMENT_DATA = 'prePaymentData',
  STRIPE_SESSION_GUID = 'stripeSessionGUID',
  TRANSACTION_GUID = 'transactionGUID',
  CONTACT_DATA = 'contactData',
  BOOLEAN_SETTINGS = 'booleanSettings',
  SERVICE_TOTALS = 'serviceTotals',
  CONTRACT_SETTINGS = 'contractSettings',
  CREATED_BY = 'createdByUserGUID',
  OWNED_BY = 'ownedByUserGUID',
}

export const InvoiceFieldGetEncryptionFields = [] as const;

export const InvoiceFieldCases = ["invoices", "invoiceGUID", "invoiceStatus", "invoiceDate", "invoiceDatePaid", "invoiceTerm", "invoiceDescription", "invoiceDetails", "invoicePurchaseOrder", "net", "tax", "clientGUID", "quoteGUID", "revenueStreamGUID", "paymentType", "paymentData", "prePaymentData", "stripeSessionGUID", "transactionGUID", "contactData", "booleanSettings", "serviceTotals", "contractSettings", "createdByUserGUID", "ownedByUserGUID"] as const;
